import { reactive, computed } from "vue";

const state = reactive({
  activities: {}
});

function start(key) {
  state.activities[key] = true;
}

function stop(key) {
  delete state.activities[key];
}

function clear() {
  Object.keys(state.activities).forEach((k) => delete state.activities[k]);
}

const isBusy = computed(() => Object.keys(state.activities).length > 0);

export default {
  state,
  start,
  stop,
  clear,
  isBusy
};
